export const COLORS = {
    BLACK: {
        100: '#FFFFFF',
        200: '#F1F1F1',
        300: '#E2E2E2',
        400: '#C6C6C6',
        500: '#ABABAB',
        600: '#777777',
        700: '#3B3B3B',
        800: '#1B1B1B',
        900: '#000000',
    },
    WHITE: {
        100: '#FFFFFF',
        200: '#F2F2F3',
        300: '#E5E5E6',
        400: '#D8D7DB',
        500: '#CAC8D0',
        600: '#BCBAC4',
        700: '#AEABBA',
        800: '#A09CB0',
        900: '#918CA6',
    },
    PRIMARY: {
        100: '#EEEAFA',
        200: '#D3C9F3',
        300: '#B5A4EA',
        400: '#9A82E3',
        500: '#8061DB',
        600: '#633FD3',
        700: '#4626A6',
        800: '#2C1868',
        900: '#11092A',
    },
    PURPLE: {
        100: '#6C667F',
        200: '#61597D',
        300: '#544A78',
        400: '#4A3E74',
        500: '#3E326C',
        600: '#372966',
        700: '#2C1F5B',
        800: '#221551',
        900: '#1D1148',
    },
    PINK: {
        100: '#FDE7F4',
        200: '#FBC1E2',
        300: '#F89BD0',
        400: '#F674BE',
        500: '#F34DAC',
        600: '#EF1090',
        700: '#B10C6A',
        800: '#730845',
        900: '#30031D',
    },
    PEACH: {
        100: '#FFEDE5',
        200: '#FFD3C2',
        300: '#FFBDA3',
        400: '#FFA785',
        500: '#FF9166',
        600: '#FF5A1A',
        700: '#CC3900',
        800: '#802400',
        900: '#330E00',
    },
    YELLOW: {
        100: '#FFF7E6',
        200: '#FEEAB8',
        300: '#FEDF95',
        400: '#FDD472',
        500: '#FDC747',
        600: '#FCB408',
        700: '#BB8402',
        800: '#795601',
        900: '#322401',
    },
    GREEN: {
        100: '#F2FAEB',
        200: '#D9F1C6',
        300: '#C4E8A5',
        400: '#AFE085',
        500: '#99D864',
        600: '#79CC33',
        700: '#599726',
        800: '#3C661A',
        900: '#18290A',
    },
    TEAL: {
        100: '#EBFAF5',
        200: '#C6F0E2',
        300: '#A6E8D1',
        400: '#85E0C1',
        500: '#63D7AF',
        600: '#33C794',
        700: '#25926D',
        800: '#185D45',
        900: '#0A291E',
    },
    BLUE: {
        100: '#E8F5FC',
        200: '#C4E5F8',
        300: '#9BD4F3',
        400: '#72C2EE',
        500: '#49B0E9',
        600: '#1A96DA',
        700: '#136D9F',
        800: '#0D4869',
        900: '#051F2D',
    },
    GRADIENTS: {
        RAINBOW: 'linear-gradient(135deg, #CE55B0 0.52%, #F34DAC 14.81%, #F48E66 29.09%, #F0B832 43.38%, #B2CE37 57.66%, #63D7AF 71.95%, #1CC2DF 86.24%, #0580E6 100.52%);',
        PINK: 'linear-gradient(135deg, #CE55B0 0%, #F34DAC 50%, #F48E66 100%);',
        GREEN: 'linear-gradient(135deg, #B2CE37 25.52%, #63D7AF 100%);',
        BLUE: 'linear-gradient(135deg, #63D7AF 0%, #1CC2DF 50%, #0580E6 100%);',
        PURPLE: 'linear-gradient(135deg, #0580E6 0%, #F34DAC 50%, #F48E66 100%);',
    },
};
